module.exports = __webpack_public_path__ + "img/Z61_03.99b0b6db.jpg";